import type { ReactNode } from 'react';

interface Props {
  kind: 'error' | 'success' | 'info';
  children: ReactNode;
}

export default function StatusMessage({ kind, children }: Props) {
  return (
    <div
      className={`${kind}-message`}
      role={kind === 'error' ? 'alert' : 'status'}
      aria-live="polite"
    >
      {children}
    </div>
  );
}
